<template>
    <section class="section__body">

        <!--- Navigation --->
        <ShipmentList_navigation />

        <!--- Container --->
        <section class="selected__container plr__12 pb__12" ref="list_container">

            <DynamicScroller
                ref="shipmentList"
                class="list dynamic-scroller-list-units"
                :items="shipmentsAndGroups"
                :key-field="'xid'"
                :min-item-size="miItemSize"
                :buffer="600"
            >
                <template #before>
                    <!-- start -->
                </template>

                <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                        :item="item"
                        :active="active"
                        :size-dependencies="[]"
                        :data-index="index"
                        :data-active="active"
                        :class="item.item_type == 'group' ? 'list-units-scroller-group-height' : 'list-units-scroller-item-height'"
                    >
                        <component
                            :is="'ShipmentList_item_'+item.item_type"
                            v-bind="item"
                        />
                    </DynamicScrollerItem>
                </template>

                <template #after>
                    <!--  end -->
                    <SectionLoading v-if="!ready || (ready && !isShipmentsLiteLoad)"/>
                    <section class="section section_type_loader loader loader_status_active"
                             v-show="isShipmentsLiteLoad && !filteredShipmentsIds.length && !filteredShipmentsPackagesIds.length"
                    >
                        <span class="loader__text">{{ $t('text.No data') }}</span>
                    </section>
                </template>
            </DynamicScroller>

        </section>
    </section>
</template>

<script>
    import {mapGetters} from "vuex";
    import {computed, defineAsyncComponent} from "vue";
    import {useToast} from "vue-toastification";

    //import TabsControl from "@/components/_base/TabsControl";
    import ShipmentList_navigation from "@/components/shipment/ShipmentList_navigation.vue";

    //intuit
    import ShipmentList_item_default from "@/components/shipment/ShipmentList_item_default.vue"
    import ShipmentList_item_group from "@/components/shipment/ShipmentList_item_group.vue"

    //prometheus

    export default {
        name: "ShipmentList",
        mixins: [],
        components: {
            // VueAutoVirtualScrollList,
            TabsControl: defineAsyncComponent(() => import("@/components/_base/TabsControl.vue")),
            ShipmentList_navigation,

            //intuit
            ShipmentList_item_default,//: defineAsyncComponent(() => import ("@/components/shipments/ShipmentsList_shipment.intuit.vue")),
            ShipmentList_item_group,

            //prometheus
        },
        data() {
            return {
                ready: false,
                interval: null,
                filterDateNow: Date.now()/1000
            }
        },
        provide(){
            return {
                filteredShipmentsIds: computed(() => this.filteredShipmentsIds),
                toast: useToast(),
            }
        },
        computed: {
            ...mapGetters([
                "getAppUserId",
                "getShipments",
                "getUserStorageKey",
                "isShipmentsLiteLoad",
                "getUserStorageKey",
                "getDateToday",
                "getShipmentsPackages",
                "getShipmentsById",
                "getShipmentsByPackageId",
                "getShipmentsDevices",
            ]),
            localStorageKey() {
                return this.getUserStorageKey + '.shipmentId'
            },
            shipments() {
                return this.getShipments.filter(s => !s.package_id)
            },
            dataList() {
                let list = [
                    ...this.shipments,
                    ...this.shipmentsPackages,
                ]
                list.sort((a, b) => {
                    if(this.routeQueryFilter.status === 'completed') {
                        return b?.completed__time?.utc - a.completed__time?.utc
                    }
                    return b?.shipping__time?.utc - a?.shipping__time?.utc
                })
                return list;
            },
            miItemSize() {
                return this.routeQueryFilter.status == 'staging' ? 100 : 44
            },
            shipmentsPackages() {
                return this.getShipmentsPackages
                    .filter(p => !p.isRemoved)
                    .map(p => {
                    return {
                        id: p.id,
                        xid: 'group' + p.id,
                        item_type: 'group',
                        name: p.name,
                        name_: p.name_,
                        status: p.status,
                        shipping_time: p?.shipping__time?.utc,
                        shipping__time: p?.shipping__time,
                        delivery_time: p?.delivery__time?.utc,
                        delivery__time: p?.delivery__time,
                        completed_at: p?.completed__time?.utc,
                        completed__time: p?.completed__time
                    }
                })
            },
            isShipmentsPage(){
                return this.mainRouteName == this.$consts.routerNames.shipments.main
            },
            activeShipmentId(){
                return (this.ready && this.isShipmentsLiteLoad && this.shipmentsAndGroups?.length) ? (this.routeFilter.shipmentId || null) : null
            },
            showMapInfo(){
                return !!this.routeMeta.showMapInfo
            },
            filteredShipmentsIds() {
                let queryFilter = this.routeQueryFilter
                //let routeFilter = this.routeFilter

                let shipments = this.shipments
                    .filter(this.filterShipments);
                    // .filter(u => u?.access_right >= accessRight.read)

                if(queryFilter.type) {
                    shipments = shipments.filter(u => u.type === queryFilter.type)
                }
                if(queryFilter.mode) {
                    shipments = shipments.filter(u => u.mode === queryFilter.mode)
                }
                if (queryFilter.name) {
                    let name = queryFilter.name?.toLocaleLowerCase()
                    let shipmentsByUnits = this.getShipmentsDevices
                        .filter(u => u?.name_?.includes(name) || u?.hw_type_?.includes(name) || u?.hw_id_?.includes(name))
                        .map(u => u.id)

                    shipments = shipments.filter(s => !!s.name_?.includes(name) || shipmentsByUnits.includes(s.unit_id))
                }
                if (queryFilter.group) {
                    shipments = shipments.filter(u => queryFilter.group === 'single' && u.id)
                }

                return shipments.map(u => u.id)
            },
            filteredShipmentsPackagesIds() {
                let queryFilter = this.routeQueryFilter
                //let routeFilter = this.routeFilter

                let shipmentsPackages = this.shipmentsPackages
                    .filter(this.filterPackages);
                    // .filter(u => u?.access_right >= accessRight.read)

                if(queryFilter.type) {
                    shipmentsPackages = shipmentsPackages.filter(u => u.type === queryFilter.type)
                }
                if(queryFilter.mode) {
                    shipmentsPackages = shipmentsPackages.filter(u => u.mode === queryFilter.mode)
                }
                if(queryFilter.group) {
                    shipmentsPackages = shipmentsPackages.filter(p => queryFilter.group === 'multiple' && p.id)
                }
                if (queryFilter.name) {
                    let name = queryFilter.name?.toLocaleLowerCase()
                    let filterPackages = shipmentsPackages.filter(u => !!u.name_?.includes(name))
                    if(!filterPackages?.length) {
                        let shipmentsByUnits = this.getShipmentsDevices
                            .filter(u => u?.name_?.includes(name) || u?.hw_type_?.includes(name) || u?.hw_id_?.includes(name))
                            .map(u => u.id)
                        let shipmentsPackageIds = this.getShipments.filter(s => (!!s.name_?.includes(name) || shipmentsByUnits.includes(s.unit_id)) && s?.package_id).map(s => s?.package_id)
                        shipmentsPackages = shipmentsPackages.filter(p => shipmentsPackageIds.includes(p.id))
                    } else {
                        shipmentsPackages = filterPackages
                    }
                }

                return shipmentsPackages.map(u => u.id)
            },
            shipmentsAndGroups(){
                if(!this.ready) return []
                return this.dataList
                    .filter(s => s.item_type == 'group' ? this.filteredShipmentsPackagesIds.includes(s.id) : this.filteredShipmentsIds.includes(s.id))
                    .map(s => {
                        return {xid: `$1-${s.type+''+s.id}`, item_type: s.item_type || 'default', itemId: s.id}
                    })
            },
            setShipmentActive() {
                return this.ready
                    && this.isShipmentsLiteLoad
                    && this.mainRouteName === this.$consts.routerNames.shipment.main
                    && (this.routeQueryFilter.status || 'active')
            },
        },
        watch: {
            setShipmentActive: {
                handler: function (newVl, oldVal) {
                    if(newVl && newVl !== oldVal) {
                        this.setActiveShipment()
                    }
                },
                immediate: true
            },
            activeShipmentId: {
                handler (newVl /*, oldVl*/) {
                    //if(this.$isDevelopment) console.log("isActive", newVl, oldVl)
                    //ToDo reset filter
                    if(newVl) {
                        this.$nextTick().then(() => this.scrollToUnit())
                        //setTimeout(() => this.scrollToUnit(), 300)
                    }
                },
                immediate: true
            },
        },
        methods: {
            filterShipments(shipment) {
                let available = true
                let completed = this.$consts?.shipment?.extendedShipmentByStatus?.includes(shipment.status)
                let shipmentActualEndTimeDate = shipment?.completed__time?.date

                if(this.routeQueryFilter.status === 'staging') {
                    available = shipment.status === 'staging' || !shipment.unit_id
                } else
                if(this.routeQueryFilter.status === 'completed') {
                    available = (shipment?.unit_id && completed)
                } else
                if(this.routeQueryFilter.status === 'unfinished') {
                    available = !completed && ((this.filterDateNow - shipment?.delivery_time) >= this.$consts.time.h24)
                }
                else {
                    available = shipment?.unit_id
                        && (!completed || (completed && this.getDateToday <= shipmentActualEndTimeDate))
                }

                return shipment.id && available
            },
            filterPackages(shipmentsPackage){
                let available = true
                let completed = this.$consts?.shipment?.extendedShipmentByStatus?.includes(shipmentsPackage.status)
                let packageActualEndTimeDate = shipmentsPackage?.completed__time?.date

                if(this.routeQueryFilter.status === 'staging') {
                    available = shipmentsPackage.status === 'staging'
                } else
                if(this.routeQueryFilter.status === 'completed') {
                    available = completed
                } else
                if(this.routeQueryFilter.status === 'unfinished') {
                    available = !completed && ((this.filterDateNow - shipmentsPackage?.delivery_time) >= this.$consts.time.h24)
                }
                else {
                    available = (!completed || (completed && this.getDateToday <= packageActualEndTimeDate))
                }
                return shipmentsPackage.id && available
            },
            scrollToUnit(){
                let shipment = this.getShipments.find(s => s.id == this.activeShipmentId)
                if (!shipment) return false;
                let scrollId = shipment.package_id || shipment.id
                let item_type = shipment.package_id ? 'group' : 'default'
                let scrollTo = this.shipmentsAndGroups.findIndex(i => i.itemId == scrollId && item_type == i.item_type)
                let height = this.$refs?.list_container?.clientHeight
                let itemSize = 100//Object.values(this.$refs.shipmentList?.vscrollData?.sizes)[1]
                if (height && itemSize) {
                    scrollTo -= Math.round((height / itemSize) / 2)
                    if (scrollTo < 0) scrollTo = 0
                }
                this.$refs?.shipmentList?.scrollToItem(scrollTo)
            },
            setActiveShipment() {
                let localeStorageKey = this.getUserStorageKey + '.shipmentId'
                let shipmentId = this.shipmentId || localStorage.getItem(localeStorageKey)
                let shipments = this.getShipments.filter(this.filterShipments);

                shipments?.sort((a,b) => {
                    return this.routeQueryFilter.status === 'completed' ?
                        b?.completed__time?.utc - a.completed__time?.utc  :
                        b.shipping__time?.utc - a.shipping__time?.utc
                })
                let shipment = shipments.find(s => s.id == shipmentId) || shipments[0]
                shipmentId = shipment?.id
                if(shipmentId) this.setRoute.shipmentId(this.$route, this.$router, shipmentId)
            }
        },
        created() {
            //if(this.$isDevelopment) console.log('ShipmentsList created')
            this.interval = setInterval(() => this.filterDateNow = Date.now()/1000, 10*1000)
        },
        mounted(){
            //if(this.$isDevelopment) console.log('ShipmentsList mounted')
            setTimeout(() => this.ready = true, this.$consts.timeoutReadyComponent)
            //setTimeout(() => {this.ready = true;}, 500)
        },
        updated() {
        },
        activated() {
            // if(this.getShipments.length && this.isShipmentsPage) {
            //     this.setActiveShipment()
            // }

            // this.$nextTick().then(() => {this.ready = true})
            // setTimeout(() => this.ready = true, this.$consts.timeoutReadyComponent)
        },
        deactivated() {
            this.ready = false
        },
        beforeUnmount() {
            if(this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        }
    }
</script>

<style lang="scss" scoped>
.selected__container {
    height: 100%;
    overflow: hidden;
}
.list {
    background: var(--units-list-bg);
}
</style>